import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onSave, onImport, onExport }) => {
  return (
    <div className="bg-white rounded-2xl shadow-lg border border-slate-200 p-6">
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
        <Button
          onClick={onSave}
          className="flex-1 bg-button hover:opacity-90 text-button-foreground shadow-lg hover:shadow-xl transition-all duration-300"
        >
          <Icon name="Save" size={20} />
          حفظ التغييرات
        </Button>

        <Button
          onClick={onImport}
          variant="outline"
          className="flex-1 border-2 border-slate-300 hover:border-indigo-500 hover:bg-indigo-50 text-slate-700 hover:text-indigo-700 transition-all duration-300"
        >
          <Icon name="Upload" size={20} />
          استيراد الجدول
        </Button>

        <Button
          onClick={onExport}
          variant="outline"
          className="flex-1 border-2 border-slate-300 hover:border-blue-500 hover:bg-blue-50 text-slate-700 hover:text-blue-800 transition-all duration-300"
        >
          <Icon name="Download" size={20} />
          تصدير التقويم
        </Button>
      </div>

      {/* Info Banner */}
      <div className="mt-4 bg-gradient-to-r from-blue-50 via-blue-50 to-slate-50 rounded-lg p-4 border border-blue-200">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} className="text-indigo-600 mt-0.5 flex-shrink-0" />
          <p className="text-sm text-indigo-900">
            يتم مزامنة التغييرات تلقائياً مع نظام الحجز. سيتم تحديث التوفر فوراً بعد حفظ التغييرات.
          </p>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;